import React from 'react';
import { COMPONENT_TYPES } from '../config/constants';
import { Mood, Skeleton, Spinner } from '@intigral/shared';
import { Carousel2 } from '@intigral/ui';
import { SectionHeaderWithPagination } from '@intigral/ui/components/SectionHeaderWithPagination';

export const CarouselLoader = ({ title = undefined, swiperSettings = undefined, children }) => (
    <div className="container full-width">
        <SectionHeaderWithPagination {...(title ? { title } : { isLoading: true })} />
        <Carousel2 isLoading swiperSettings={swiperSettings}>
            {children}
        </Carousel2>
    </div>
);

export default ({ componentName }) => {
    switch (componentName) {
        case COMPONENT_TYPES.REWIND_CAROUSEL:
        case COMPONENT_TYPES.STREAMING_CAROUSEL:
            return (
                <CarouselLoader>
                    <Mood isLoading />
                </CarouselLoader>
            );
        case COMPONENT_TYPES.SEARCH_RESULTS:
            return <Spinner opaqueBg />;
        default:
            return (
                <div style={{ zIndex: '12', position: 'fixed', inset: '0' }}>
                    <Skeleton animation />
                    <Spinner />
                </div>
            );
    }
};
